import React, { useState } from "react";
import { Card, Dropdown} from "react-bootstrap";
import RulesListExpandedElement from "./RulesListExpandedElement";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export default function RulesListElement(props) {
    const [expanded, setExpansion] = useState(true);

    const dropdown = [
        { title: "Distance to golden standard", id: 'struct2GSrules',
            default: { ruleType: "struct2GSrules", threshold: 4, grading: 100, percentage: 95, organ: props.structname, otherOrgan: null, created: true }
        },
        { title: "Penalise overlap to other structures", id: 'dist2OtherRules',
            default: { ruleType: "dist2OtherRules", threshold: 5, grading: 10, percentage: 10, organ: props.structname, otherOrgan: props.otherStructs[0], created: true }
        },
        { title: "Penalise structure length", id: 'lengthRules',
            default: { ruleType: "lengthRules", threshold: 3, grading: 10, percentage: 0, organ: props.structname, otherOrgan: null, created: true }
        },
        { title: "Penalise volume differences", id: 'volumeRules',
            default: { ruleType: "volumeRules", threshold: 0, grading: 10, percentage: 10, organ: props.structname, otherOrgan: null, created: true }
        }
    ];

    function clickDropdownItem(def) {
        props.data.push(def.default);
        props.callback(props.data);
        setExpansion(true);
    }

    return (
        <Card>
            <Card.Header>
                <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
                    <span style={{ width: '50%' }} onClick={() => setExpansion(!expanded)}>
                        {props.structname}
                    </span>

                    <Dropdown>
                        <Dropdown.Toggle size='sm' variant='success'>
                            <FontAwesomeIcon icon={faPlus} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {dropdown.map((item, i) => (
                                <Dropdown.Item key={i} onClick={() => clickDropdownItem(item)}>
                                    {item.title}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </Card.Header>
            {expanded ? (
                <RulesListExpandedElement
                    otherStructs={props.otherStructs}
                    data={props.data}
                    callback={props.callback}
                />
            ) : (
                ''
            )}
        </Card>
    );
}